/**
 * Foo lion / shi / "Heaven dog" silhouette — the temple guardians that flank
 * the entrance to Mann's Chinese Theatre. Used as the mascot for empty
 * states. Hand-drawn approximation, not a tracing.
 */
export function FuLion({
  className,
  facing = "right",
}: {
  className?: string;
  facing?: "left" | "right";
}): JSX.Element {
  return (
    <svg
      viewBox="0 0 200 240"
      className={className}
      role="presentation"
      aria-hidden="true"
      style={{ transform: facing === "left" ? "scaleX(-1)" : undefined }}
    >
      <defs>
        <linearGradient id="lion-bronze" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#C7A24A" />
          <stop offset="60%" stopColor="#8B6A22" />
          <stop offset="100%" stopColor="#3B2A1F" />
        </linearGradient>
      </defs>

      {/* Pedestal base */}
      <rect x="40" y="200" width="120" height="30" fill="url(#lion-bronze)" stroke="#1A0B0B" strokeWidth="1" />
      <rect x="50" y="210" width="100" height="3" fill="#1A0B0B" opacity="0.4" />

      {/* Lion body */}
      <path
        d="M 70 200
           Q 60 170 70 140
           Q 55 130 55 110
           Q 55 80 80 65
           Q 90 55 110 55
           Q 130 55 145 70
           Q 160 80 160 105
           Q 160 125 150 135
           Q 160 165 155 200 Z"
        fill="url(#lion-bronze)"
        stroke="#1A0B0B"
        strokeWidth="1.5"
      />

      {/* Mane curls — circles around the head */}
      <g fill="url(#lion-bronze)" stroke="#1A0B0B" strokeWidth="0.8">
        <circle cx="60" cy="80" r="9" />
        <circle cx="58" cy="98" r="8" />
        <circle cx="62" cy="116" r="7" />
        <circle cx="155" cy="80" r="9" />
        <circle cx="158" cy="98" r="8" />
        <circle cx="154" cy="116" r="7" />
        <circle cx="80" cy="60" r="8" />
        <circle cx="100" cy="55" r="7" />
        <circle cx="120" cy="55" r="7" />
        <circle cx="140" cy="60" r="8" />
      </g>

      {/* Face — eyes + brow + snout */}
      <g fill="#1A0B0B">
        {/* Eyes */}
        <ellipse cx="92" cy="100" rx="4" ry="5" />
        <ellipse cx="123" cy="100" rx="4" ry="5" />
        {/* Pupils — gold glints */}
        <circle cx="93" cy="100" r="1.5" fill="#E8C977" />
        <circle cx="124" cy="100" r="1.5" fill="#E8C977" />
        {/* Brow ridges */}
        <path d="M 84 92 Q 92 88 100 92" fill="none" stroke="#1A0B0B" strokeWidth="2" />
        <path d="M 115 92 Q 123 88 131 92" fill="none" stroke="#1A0B0B" strokeWidth="2" />
        {/* Snout */}
        <path d="M 100 115 Q 107 122 114 115 Q 110 130 107 130 Q 104 130 100 115 Z" />
        {/* Mouth — gold teeth peek */}
      </g>
      <path d="M 95 132 Q 107 140 119 132" fill="none" stroke="#1A0B0B" strokeWidth="1.8" />
      <path d="M 102 135 L 104 142 M 110 135 L 112 142" stroke="#E8C977" strokeWidth="1" />

      {/* Front legs */}
      <path d="M 80 175 Q 75 195 78 200 L 92 200 Q 95 195 92 175 Z" fill="url(#lion-bronze)" stroke="#1A0B0B" strokeWidth="1" />
      <path d="M 123 175 Q 120 195 123 200 L 137 200 Q 140 195 135 175 Z" fill="url(#lion-bronze)" stroke="#1A0B0B" strokeWidth="1" />

      {/* Ball under right paw (traditional male lion) */}
      <circle cx="130" cy="205" r="6" fill="url(#lion-bronze)" stroke="#1A0B0B" strokeWidth="0.8" />
      <path d="M 124 205 Q 130 200 136 205 M 124 205 Q 130 210 136 205" stroke="#1A0B0B" strokeWidth="0.5" fill="none" />
    </svg>
  );
}
